import { createSelector } from 'reselect';
import { selectGallery, selectIsTimeoutError, selectIsSolarApihasError } from './fromState';

const selectSolarCallStatus = createSelector(
    [selectGallery, selectIsTimeoutError, selectIsSolarApihasError],
    (gallery, timeoutError, solarApihasError) => gallery && !timeoutError && !solarApihasError
);

export default selectSolarCallStatus;
